import { useState, useCallback } from 'react';
import moment from 'moment';
import { DateRangeState, FilterRoute } from '@zonofi/zono-money-store';
import { useUrlDateRange } from './use-url-date-range';

export const useCustomDateRange = (
  route?: FilterRoute,
  dateRangeSelection?: DateRangeState,
  setDateRangeSelection?: (val: DateRangeState | null) => void,
  selectionMode?: 'date' | 'dateRange'
) => {
  const { dateRangeFromUrl, updateRange } = useUrlDateRange({ route });

  const [showCalender, setShowCalender] = useState(false);

  const handleSelect = useCallback(
    (ranges: any) => {
      const newRange: DateRangeState = {
        key: 'selection',
        startDate: moment(ranges.selection.startDate).startOf('day').toDate(),
        endDate:
          selectionMode === 'dateRange'
            ? moment(ranges.selection.endDate).endOf('day').toDate()
            : moment(ranges.selection.startDate).startOf('day').toDate(),
      };
      setDateRangeSelection?.(newRange);
    },
    [selectionMode]
  );

  const applyNewDateRange = (dateRange?: DateRangeState) => {
    updateRange(dateRange ?? (dateRangeSelection as DateRangeState));
    setShowCalender(false);
  };

  return {
    showCalender,
    setShowCalender,
    dateRangeFromUrl,
    handleSelect,
    applyNewDateRange,
  };
};
